import { isEmpty } from "@swiggy-private/core-ui";
import {
    ItemValidVariants,
    ItemValidVariantsV2,
    ItemValidAddons,
    CartItem,
    CartItemWithUUID,
    FREEBIETYPE,
    REWARD_TYPE,
    ItemsPresentationConfig,
    ReviewedCartApiResponse,
    OPT_MERCH_FREEBIE_TAG,
    ITEM_TYPE,
    ItemType,
} from "@swiggy-private/cart-types";

export const getAddonVariantString = (addons: CartItem["addons"] = [], variants: CartItem["variants"] = []): string => {
    const addonNames = addons.map((addon) => addon.name);
    const variantNames = variants.map((variant) => variant.name);

    return [...addonNames, ...variantNames].join(", ");
};

export const getVariantsNew = (item: CartItem): ItemValidVariants["variant_groups"] | [] =>
    item.valid_variants?.variant_groups ?? [];

export const getVariantsV2 = (item: CartItem): ItemValidVariantsV2["variant_groups"] | [] =>
    item.valid_variants_v2?.variant_groups ?? [];

export const getAddons = (item: CartItem): ItemValidAddons[] | [] => item.valid_addons ?? [];

export const isItemCustomizable = (item: CartItem): boolean => {
    return (
        !item.hide_customisation &&
        (!isEmpty(getVariantsNew(item)) || !isEmpty(getVariantsV2(item)) || !isEmpty(getAddons(item)))
    );
};

export const isFreebieOptInItem = (item: CartItem | CartItemWithUUID): boolean =>
    item.rewardType === REWARD_TYPE.FREEBIE && item.freebieType === FREEBIETYPE.OPTIN;

export const getItemsPresentationConfig = (
    groupTagDetails?: ReviewedCartApiResponse["group_tag_details"],
    item?: CartItemWithUUID,
): ItemsPresentationConfig => {
    const groupTag = groupTagDetails?.find((groupTag) => groupTag?.group_tag_id === item?.item_group_tag_id);
    return {
        titleColor: groupTag?.title_color,
        background: groupTag?.group_background_color,
    };
};

export const isMerchItem = (item: CartItem | CartItemWithUUID): boolean => {
    return item.item_offer_tags?.includes(OPT_MERCH_FREEBIE_TAG) || false;
};

export const getItemType = (item: CartItem | CartItemWithUUID): ItemType => {
    return isMerchItem(item) ? ITEM_TYPE.MERCH : ITEM_TYPE.FOOD;
};
